<template>
<section id="clHowToGet">
  <h2 class="instH2">Как получить кредитную линию</h2>
  <div id="clHowToGetWrap">
    <div class="clHowToGetItem">
      <p>Заполнить анкету</p>
      <p>После проверки данных будет установлен персональный кредитный лимит на срок до 10 лет</p>
      <p>1</p>
    </div>
    <div class="clHowToGetItem">
      <p>Запросить сумму</p>
      <p>Запросите необходимую сумму в рамках одобренного лимита</p>
      <p>2</p>
    </div>
    <div class="clHowToGetItem">
      <p>Возвращать сумму</p>
      <p>Вносите платежи по графику, как удобно</p>
      <p>3</p>
    </div>
    <div class="clHowToGetItem last">
      <p>Пользоваться деньгами снова</p>
      <p>После погашения лимит восстанавливается, и деньги снова доступны</p>
      <p>4</p>
    </div>
  </div>
  <instApplyButton></instApplyButton>
</section>
</template>

<script>
export default {
  name: "clHowToGet",
  components: {
    instApplyButton: () => import('@/components/inst/instApplyButton.vue'),
  }
}
</script>

<style scoped>
#clHowToGetWrap{background: white; padding: var(--font-size-30) var(--font-size-20);border-radius: var(--font-size-20);font-family: 'Roboto';}
.clHowToGetItem{background: var(--color-gray-type4);border-radius: var(--font-size-20);margin-bottom: var(--font-size-20); padding: var(--font-size-20) var(--font-size-70) var(--font-size-20) var(--font-size-24);position: relative;color:var(--color-black-type2);min-height: var(--font-size-80)}
.clHowToGetItem.last{margin-bottom: 0;background: var(--color-green);color:white;}
.clHowToGetItem p:nth-child(1){font-size: var(--font-size-18);font-weight: 500;margin-bottom: var(--font-size-10)}
.clHowToGetItem p:nth-child(2){font-size: var(--font-size-16);font-weight: 100;}
.clHowToGetItem p:nth-child(3){font-size: var(--font-size-64);color:rgba(0,0,0,.08);font-family: 'Ubuntu';font-weight: bold;position: absolute;top:50%;transform: translateY(-50%);right:var(--font-size-14)}
.clHowToGetItem.last p:nth-child(3){color:rgba(255,255,255,.25);}

@media screen and (min-width: 760px) {
  #clHowToGetWrap{padding: var(--font-size-40) var(--font-size-60);}
  #clHowToGetWrap{display: flex;align-items: stretch;justify-content: flex-start;flex-wrap: nowrap;gap: var(--font-size-15);}
  .clHowToGetItem{width: calc((100% - (var(--font-size-15) * 3)) / 4);margin-bottom: 0;}
}
</style>
